<script lang="ts" setup>
import { SortingModalItemProps } from "~/components/Filters/Utils/SortingModalItem.props"

withDefaults(defineProps<SortingModalItemProps>(), {
  lessSpacing: false,
  hideBorder: false,
  active: false
})

const emit = defineEmits<{ (e: "onClick"): void }>()
</script>

<template>
  <button
    class="sorting-modal-item flex w-full cursor-pointer justify-between"
    :class="{
      'pb-4': !lessSpacing,
      'pb-2': lessSpacing,
      'border-b border-black-10': !hideBorder
    }"
    @click="emit('onClick')"
  >
    <span :class="{ pig: !active, 'pig-bold': active }">{{ label }}</span>
    <UtilsIcon name="Checkmark.svg" v-show="active" class="h-6 w-6" />
  </button>
</template>
